import classNames from "classnames";
import Link from "next/link";
import * as React from "react";
import { ImageFlux } from "@components/ImageFlux";
import type {
  UsersMasterShopImageType,
  UsersShopImageType,
} from "@graphql/__generated__/types";
import { paths } from "@libs/paths";
import { masterImageId2Anchor } from "@libs/utils/photo";
import styles from "./index.module.css";

type Props = {
  shopUuid: string;
  shopImages: Array<UsersShopImageType>;
  masterShopImages: Array<UsersMasterShopImageType>;
};

// 「カバー」画像はこのパーツのカテゴリタイルでは使わないためフィルタ用にidを定義
const idCover = 1;

const Photo: React.FC<Props> = (props) => {
  const { shopUuid, shopImages, masterShopImages } = props;

  // 公開店舗にはカバーが必ず1枚あるため通常は起こらないが、
  // 万一写真が0枚でも allTileImage が undefined でクラッシュしないようガードする
  if (shopImages.length === 0) {
    return null;
  }

  // カテゴリごとに先頭1枚をタイルのサムネイルとして用いる（写真0枚のカテゴリはタイルを出さない）
  const categoryTiles = masterShopImages
    .filter((masterShopImage) => masterShopImage.id !== idCover)
    .flatMap((masterShopImage) => {
      const thumbnailImage = shopImages.find(
        (shopImage) => shopImage.masterShopImageId === masterShopImage.id
      );
      return thumbnailImage ? [{ masterShopImage, thumbnailImage }] : [];
    });

  // 最後の「すべて」の画像はカテゴリを問わず動的に選ぶ。
  // カテゴリタイルと同じ画像が並ばないよう未使用の写真を優先し、無ければ先頭の写真を用いる
  const usedImageIds = categoryTiles.map(
    ({ thumbnailImage }) => thumbnailImage.id
  );
  const allTileImage =
    shopImages.find((shopImage) => !usedImageIds.includes(shopImage.id)) ??
    shopImages[0];

  return (
    <>
      <section className={styles.photo}>
        <div className={classNames(styles.columnInner, "l-main__innerWidth")}>
          <h1 className={`${styles.contentTitle} c-contentTitle`}>写真</h1>
          <div className={styles.list}>
            {categoryTiles.map(({ masterShopImage, thumbnailImage }) => (
              <div className={styles.items} key={masterShopImage.id}>
                <Link
                  href={paths.shopPhoto(
                    shopUuid,
                    masterImageId2Anchor(masterShopImage.id)
                  )}
                >
                  <ImageFlux
                    imageType={"thumbnail"}
                    url={thumbnailImage.imageUrl}
                    alt={masterShopImage.name}
                  />
                  <p className={styles.cat}>{masterShopImage.name}</p>
                </Link>
              </div>
            ))}
            <div className={styles.items}>
              <Link href={paths.shopPhoto(shopUuid)}>
                <ImageFlux
                  imageType={"thumbnail"}
                  url={allTileImage.imageUrl}
                  alt={"すべて"}
                />
                <p className={`${styles.cat} ${styles.catAll}`}>
                  すべて
                  <br />({shopImages.length})
                </p>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Photo;
